import React from 'react';
import Modal from '@ntuctech/devex-tangram/Modal';
import ModalContent from '@ntuctech/devex-tangram/ModalContent';
import Typography from '@ntuctech/devex-tangram/Typography';
import { Formik } from 'formik';
import styled from 'styled-components';
import { object as YupObject } from 'yup';

import { fetcherApiRoute } from '../../services/api/fetcher';
import { addressValidation } from '../../services/input-validator';
import LpAddressFormContent, { getInitialFormData } from '../LinkPoints/LpAddressFormContent';
import PageTitle from '../PageTitle';

const ERROR_CANNOT_APPLY_CARD = 'Unable to apply card';

const AdressSc = styled(Modal)`
  border-radius: 0.25rem;
  padding: 2.5rem 3.5rem;
  width: 30rem;
  max-height: calc(100% - 6rem);
  overflow-y: scroll;

  .display-text {
    margin-bottom: 1rem;
  }
`;

const AddressForm = (props) => {
  const {
    initialFormData,
    openAddressModal,
    handleOpenAddressForm,
    handleOpenFinish,
    nameOnCard,
    handleOpenError,
    setError,
    setFinishModalMsg,
  } = props;

  const initialValues = getInitialFormData(initialFormData);

  const AddressSchema = YupObject().shape({
    blockNumber: addressValidation.requiredValidation('block number'),
    roadName: addressValidation.requiredValidation('road name'),
    floorNumber: addressValidation.floorUnitValidation({
      fieldName: 'floor and unit number',
    }),
    unitNumber: addressValidation.floorUnitValidation({
      fieldName: 'floor and unit number',
    }),
  });

  const handleOnSubmit = (values, actions) => {
    fetcherApiRoute('/api/cards/apply-card', {
      method: 'POST',
      body: JSON.stringify({
        body: {
          name: nameOnCard, //optional
          address: {
            block_number: values.blockNumber,
            road_name: values.roadName,
            building_name: values.buildingName,
            postal_code: values.postalCode,
            floor_number: values.floorNumber,
            unit_number: values.unitNumber,
          },
        },
      }),
    })
      .then((res) => {
        if (res.cardNumber) {
          setFinishModalMsg(res.message);
          actions.setSubmitting(false);
          handleOpenAddressForm(false);
          handleOpenFinish(true);
        }
      })
      .catch((err) => {
        setError({
          title: ERROR_CANNOT_APPLY_CARD,
          body: err.message || 'Something went wrong.',
        });
        handleOpenAddressForm(false);
        handleOpenError(true);
      });
  };

  return (
    <AdressSc open={openAddressModal}>
      <PageTitle boxMb={2}>Apply for free Link card</PageTitle>
      <Typography variant="body2" className="display-text">
        We will send your new card to the address below:
      </Typography>
      <ModalContent>
        <Typography variant="h6">Delivery address</Typography>
      </ModalContent>
      <Formik
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        validationSchema={AddressSchema}
      >
        {(formikProps) => (
          <LpAddressFormContent {...formikProps} {...props} initialValues={initialValues} />
        )}
      </Formik>
    </AdressSc>
  );
};

export default AddressForm;
